import React from 'react'
import './Footer.css'
import Instagram from '../../assets/instagram.png'
import Logo from '../../assets/logositee.png'
import WhatsApp from '../../assets/whats.png'

const Footer = () => {
  return (
    <div className="Footer-container">
        <hr />
        <div className="footer">
            <div className="social-links">
              <a href='https://www.instagram.com/jaylmadinizpersonal/'>
                <img src={Instagram} alt="" />
              </a>
              <a href='https://api.whatsapp.com/send/?phone=5587992048194&text=Ol%C3%A1%2C+gostaria+de+saber+como+funciona+sua+consultoria.+%0AVoc%C3%AA+pode+me+ajudar%3F&type=phone_number&app_absent=0'>
                <img src={WhatsApp} alt="" />
              </a>
            </div>
            <div className="logo-footer">
              <img src={Logo} alt="" />
              <p className='cref'>CREF: 020444-G /PE</p>
            <hr />
              <p>Copyright © 2020 Jaylma Diniz | Desenvolvido por Regiane Melo </p>
            </div>
        </div>
        <div className="blur footer-blur"></div>
        

    </div>
  )
}

export default Footer